import React from 'react';
import { Link } from 'gatsby';

import {
	EnvelopeSvg,
	FacebookSvg,
	InstagramSvg,
	TwitterSvg,
	MastodonSvg,
	BlueskySvg,
} from "./svg"

import '../../styles/common/social-icons.scss';

const SocialIcons = (props) => (
	<ul className="social-icons">
		<li>
			<a href="https://www.facebook.com/PublicDomainReview" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
				{ FacebookSvg }
			</a>
		</li>
		<li>
			<a href="https://twitter.com/PublicDomainRev" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
				{ TwitterSvg }
			</a>
		</li>
		<li>
			<a href="https://www.instagram.com/publicdomainrev/" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
				{ InstagramSvg }
			</a>
		</li>
		<li>
			<a href="https://bsky.app/profile/publicdomainrev.bsky.social" aria-label="Bluesky" target="_blank" rel="noopener noreferrer">
				{ BlueskySvg }
			</a>
		</li>
		<li className="hide-in-sticky-header">
			<a href="https://mastodon.social/@publicdomainrev" aria-label="Mastodon" target="_blank" rel="me noopener noreferrer">
				{ MastodonSvg }
			</a>
		</li>
		{(props.withNewsletter) ? (
			<li>
				<Link aria-label="Subscribe to Newsletter" to="/subscribe" className="envelope">
					{ EnvelopeSvg }
				</Link>
			</li>
		) : null}
	</ul>
);

export default SocialIcons;
